/**
 * Bounded exponential backoff for retrying *transient* access-token refresh
 * failures (network blips, timeouts). Interactive-required errors are NOT
 * retried — they go through the auth-recovery circuit-breaker instead. Bounding
 * the retries stops a persistent transient failure from becoming a tight loop.
 */
export const REFRESH_BACKOFF_BASE_MS = 5_000;
export const REFRESH_BACKOFF_MAX_MS = 5 * 60_000;
export const MAX_TRANSIENT_REFRESH_RETRIES = 5;

/** Delay before the next transient retry for a 0-indexed attempt, capped. */
export const computeRefreshBackoffMs = (attempt: number): number => {
  const exponent = Math.max(0, attempt);
  const exponential = REFRESH_BACKOFF_BASE_MS * 2 ** exponent;
  return Math.min(exponential, REFRESH_BACKOFF_MAX_MS);
};
